module.exports = __webpack_public_path__ + "img/video-preview.2bc4a9a8.jpg";